import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimTagNamePipe',
  standalone: false,
})

export class TrimTagNamePipe implements PipeTransform {
  public transform(value: string, modify: boolean): string {
    if(value.length > 3 && modify) {
      return value?.slice(0, 3) + '.';
    } else {
      return value;
    }
  }
}